module.exports = __webpack_public_path__ + "img/logo.d8595258.png";